import { customElement, property, state } from 'lit/decorators.js';
import type { ClassInfo } from 'lit/directives/class-map.js';
import { Unsubscribe } from '@common/lit/store';
import type { Callback } from '@common/lit/store/state';
import { consentStore } from '@src/store';

import { BaseComponent } from './BaseComponent';

@customElement('tef-coms-save-button')
export class TefComsSaveButton extends BaseComponent {
  @property({ type: Boolean }) cloak : boolean = false;

  @state() disabled : boolean = true;

  unsubscribe : Unsubscribe;

  constructor() {
    super();
    this.unsubscribe = consentStore.subscribe(this.handleConsentUpdate.bind(this) as Callback);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsubscribe();
  }

  handleConsentUpdate() {
    if (consentStore.hasConsentChange()) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }

  override render() {
    return this.getTemplateFn('tefComsSaveButton')();
  }

  handleClick(event : PointerEvent) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }

  get cssClasses() : ClassInfo {
    return { button: true, 'button-default--prio-secondary': true, 'button-tag--state-disabled': this.disabled };
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
